module.exports = {
  baseApi: process.env.VUE_APP_BASE_API,
  graphqlHttp: process.env.VUE_APP_GRAPHQL_HTTP,
  graphqlHttpPublic: process.env.VUE_APP_GRAPHQL_HTTP_PUBLIC,
  graphqlBase: process.env.VUE_APP_GRAPHQL_BASE,
  societyApi: process.env.VUE_APP_SOCIETY_API,
  sentryDsn: process.env.VUE_APP_SENTRY_DSN
}
